import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { QuickSearchService } from '../services/quick-search.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-grid-quicksearch',
  templateUrl: './quicksearch.component.html',
  styles: [
`
.quicksearch {
  position: relative;
  display: inline-block;
}

.search-input {
  border: 1px solid rgba(0,0,0,.15);
  border-radius: .25em;
  color: #55595c;
  line-height: 1.25;
  width: 220px;
  padding-right: 24px;
}

.clear-icon {
  position: absolute;
  z-index: 2;
  color: #777;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  font-size: 9px;
  line-height: 1;
  cursor: pointer;
}
`
  ]
})
export class GridQuickSearchComponent implements OnInit, OnDestroy{
  constructor(private quickeSearchService: QuickSearchService) {}

  // View Properties
  public text: string;

  // Outputs
  @Output() quickSearchEvent = new EventEmitter<string>();

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.quickeSearchService.guickSearchReset$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        this.resetQuickSearch();
    });
    this.quickeSearchService.guickSearchValue$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this.text = value;
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public onCloseClick() {
    this.text = "";
    this.quickSearchEvent.emit(this.text);
  }

  public onKeyDown(event): void {
    if (event.keyCode == 13) { // Enter
      this.quickSearchEvent.emit(this.text);
    }

    if (event.keyCode == 27) { // Esc
      this.text = "";
      this.quickSearchEvent.emit(this.text);
    }
  }

  public onValueChange(value: string) {
    if (!value){
      this.quickSearchEvent.emit("");
    }
  }

  public resetQuickSearch() {
    this.text = "";
  }
}
